import { z } from "zod";
export const featureFlagSchema = z.object({
    id: z.number(),
    flagKey: z.string(),
    description: z.string().nullable(),
    enabledGlobal: z.boolean(),
    overrides: z
        .array(z.object({
        idcompany: z.number(),
        enabled: z.boolean(),
        note: z.string().nullable(),
    }))
        .default([]),
});
export const toggleFlagSchema = z.object({
    enabledGlobal: z.boolean(),
});
export const setOverrideSchema = z.object({
    idcompany: z.number().int().positive(),
    enabled: z.boolean(),
    note: z.string().max(255).optional(),
});
//# sourceMappingURL=flag.js.map